import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MealPlansService {
  constructor(private http: HttpClient) {}

  getAllMealPlans(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/meal-plans/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response[0]);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getAllActiveMealPlans(hotelId?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/meal-plans/get-all`, {
          params: hotelId ? { hotel: hotelId } : {},
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  getMealPlanByID(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/meal-plans/get/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  createMealPlan(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/meal-plans/create`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateMealPlan(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/meal-plans/update`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  search(googleID: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/meal-plans/search`, {
          params: {googleID },
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
